import { Container } from 'reactstrap';
import { useAppDispatch, useAppSelector } from 'hooks/hooks';
import { alertSlice } from 'reducers/alert.slice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DataAlert = () => {
    const dispatch = useAppDispatch();
    const alert = useAppSelector(x => x.alert);
    if (!alert) return null;
    
    return (
        <Container>
            <div className={`alert alert-dismissible alert-${alert.alertType} fade show`} role="alert">
                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => dispatch(alertSlice.actions.clear())}></button>
                <FontAwesomeIcon icon={["fas", alert.icon]} size="lg" />
                    &nbsp;
                    {alert.alertMessage.message}
                </div>
        </Container>
    );
}

export default DataAlert;